import { render } from "./Check.vue?vue&type=template&id=512ab771"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"
script.render = render

export default script